import React from 'react';
import { Link } from 'react-router-dom';

import { UserOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  MenuProps,
} from 'antd';

import { UserDto } from 'lib_api/lib/api/gen';

import { useUserStore } from 'hooks/UserStoreContext';
import { useAuthentication } from 'hooks/utils/authentication';
import { getUserLabel } from 'utils/UserUtils';

interface ProfileButtonProps {
  urlProfil?: string;
  urlUsersAccount?: string;
}

function buildMenu(
  urlProfil: string | undefined,
  urlUsersAccount: string | undefined,
  user: UserDto,
  onClickLogout: () => void,
): MenuProps {
  const items = [];

  if (urlProfil !== undefined) {
    items.push({
      key: '1',
      label: <Link to={urlProfil}>Profil</Link>,
    });
  }

  const usersAccountButton = displayUsersAccountButton(urlUsersAccount, user);
  if (usersAccountButton) {
    items.push({
      key: '2',
      label: usersAccountButton,
    });
  }

  items.push({
    key: '3',
    label: <span onClick={onClickLogout}>Déconnexion</span>,
  });

  return { items };
}

function displayUsersAccountButton(
  urlUsersAccount: string | undefined,
  user: UserDto,
): React.ReactNode {
  const isUserGestionnaireLocal = user.gestionnaireLocal ?? false;
  return urlUsersAccount !== undefined && isUserGestionnaireLocal ? (
    <Link to={urlUsersAccount}>Comptes utilisateurs</Link>
  ) : null;
}

function ProfileButton({
  urlProfil,
  urlUsersAccount,
}: ProfileButtonProps): React.ReactElement {
  const user = useUserStore();
  const { redirectLogout } = useAuthentication();

  return (
    <AntdDropdown
      menu={buildMenu(urlProfil, urlUsersAccount, user, redirectLogout)}
    >
      <AntdButton
        icon={<UserOutlined />}
        type="default"
        shape="round"
        size="middle"
      >
        {getUserLabel(user)}
      </AntdButton>
    </AntdDropdown>
  );
}

export default ProfileButton;
